export default {
  pages: [],
  activePage: {},
  settings: {},
  gates: [],
  user: null,
  subscriptions: [],
  challenges: [],
  trialDays: null,
  activeChallengePage: null,
  couponData: {},
  selectedOrder: { sku: '', plan: '' },
  fromChallenge: false,
  showAlert: false,
  locale: 'en',
  selectedSubscription: {},
  authModalType: 'signup'
}
